
const TestimonialSection = () => {
  return (
    <section className="bg-[#FAFAFA] py-40">
      <div className="w-4/5 mx-auto">
        <div className="max-w-4xl mx-auto">
          <h2
            className="text-5xl font-bold text-[#2B2D33] leading-tight mb-12 text-center"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Independent &amp; Software-Neutral
          </h2>

          <p className="text-lg text-[#6B6D72] leading-relaxed text-center">
            Vantage Commercial Advisory does not sell software, receive referral commissions, or implement technology platforms. We identify process and visibility deficiencies, define capability requirements, and guide leadership teams toward disciplined operational improvement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
